import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ConfirmStopModal from "../../shared/ConfirmStopModal";
import { PROJECT_COLOR, PROJECT_COLOR_DARK } from "../../../constants/colors";
import { useSkillSheetMainStepper } from "../context/SkillSheetMainStepperContext";

// デモ：フォームの下に置くアクションバー。
// 左＝入力のリセット（控えめ）、右＝本登録して内容を引き継ぐ（主役CTA）。
// ボタンの見た目は StepperNavigation（前へ/一時保存/次へ）に合わせる。
export default function DemoFormActions({ onReset, onSignupTransfer }) {
  const { clearDemoForm } = useSkillSheetMainStepper();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleConfirm = () => {
    clearDemoForm();
    onReset?.(); // step① に戻す
    setConfirmOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          // スマホ：縦積み（主役CTAを上、破壊的な「リセット」を下）で誤タップを防ぐ
          flexDirection: { xs: "column-reverse", sm: "row" },
          justifyContent: { sm: "space-between" },
          alignItems: "center",
          gap: { xs: 1.5, sm: 2 },
          mt: 3,
        }}
      >
        <Button
          size="small"
          startIcon={<RestartAltIcon />}
          onClick={() => setConfirmOpen(true)}
          sx={{
            color: "#6b7280",
            "&:hover": { bgcolor: "rgba(107, 114, 128, 0.06)" },
          }}
        >
          入力をリセット
        </Button>

        <Button
          variant="contained"
          onClick={onSignupTransfer}
          endIcon={<ChevronRightIcon />}
          sx={{
            bgcolor: PROJECT_COLOR,
            color: "#fff",
            fontWeight: "bold",
            py: 1.5,
            px: 4,
            width: { xs: "100%", sm: "auto" },
            "&:hover": { bgcolor: PROJECT_COLOR_DARK },
          }}
        >
          本登録して内容を引き継ぐ
        </Button>
      </Box>

      <ConfirmStopModal
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleConfirm}
        title="入力内容をリセット"
        message="このブラウザに保存されたデモの入力内容がすべて消えます。この操作は取り消せません。"
        confirmLabel="リセットする"
      />
    </>
  );
}
